/**
 * @file JobHeaderCustomBadgeSlot.tsx
 *
 * @fileoverview This component renders additional things to the job header section next to the featured badge
 * and can be used to add custom badge to this section.
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobHeaderCustomBadgeSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<Job>;
}

export default function JobHeaderCustomBadgeSlot({
  job,
}: JobHeaderCustomBadgeSlotProps) {
  return null;
}

export { JobHeaderCustomBadgeSlot };
